module.exports = __webpack_public_path__ + "static/media/gallery_17.abb82639.png";